<script>
    import { onMount } from "svelte";

    import { Loader } from "../../../../Components/Common/index.svelte";
    import { isObjectEmpty } from "../../../../Utils/utilFunctions.svelte";

    import {
        workersCompensation,
        trafficAccidentAuthorities,
    } from "../../../../stores";

    export let matchPatientStatus = 0,
        matchPatientObj = {},
        isPatientMatched = false,
        patientDetails = {},
        patientContactDetails = {};

    let isFromCreate = true,
        isFromQuote = false;

    export let insuranceDetails = {},
        workerCompensation,
        workerCompensationObj = {},
        trafficAuthority,
        trafficAuthorityObj = {},
        publicInPrivateObj = {},
        enableChangeEncounterDoctor = false;

    export let insuranceDetailsRef;

    let defaultPatientDetails = {};

    $: displayMatchPatientStatus = _getMatchPatientStatus(matchPatientStatus);

    $: isSamePatient = _checkSamePatient(matchPatientObj);

    onMount(() => {
        defaultPatientDetails = { ...patientDetails };
    });

    const applyPatientDetails = async () => {
        patientDetails = {
            ...matchPatientObj,
            birthDate: matchPatientObj.birthDate.split("T")[0],
        };

        const { patientContacts } = matchPatientObj;

        if (patientContacts && patientContacts.length) {
            if (patientContacts.some((contact) => contact.useAsContact))
                patientContactDetails = patientContacts.find(
                    (contact) => contact.useAsContact,
                );
            else patientContactDetails = patientContacts[0];
        }

        await _syncInsuranceDetails(matchPatientObj);

        matchPatientObj = {};

        isPatientMatched = true;
    };

    // HELPER FUNCTIONS
    const _getMatchPatientStatus = (status) => {
        const res = {};

        switch (status) {
            case 0:
            default:
                res.displayStatus = "";
                res.textStyle = "";
                isPatientMatched = false;
                break;
            case 1:
                res.displayStatus = "Matching patient";
                res.textStyle = "";
                isPatientMatched = false;
                break;
            case 2:
                res.displayStatus = "Patient matched";
                res.textStyle = "text-secondary";
                isPatientMatched = true;
                break;
            case 3:
                res.displayStatus = "No patient matched";
                res.textStyle = "text-error";
                isPatientMatched = false;
                break;
        }

        return res;
    };

    const _checkSamePatient = (patient) => {
        if (isObjectEmpty(patient)) return true;

        const { firstName, middleName, lastName, birthDate, title, sex } =
            patient;
        const {
            firstName: dfirstName,
            middleName: dmiddleName,
            lastName: dlastName,
            birthDate: dbirthDate,
            title: dtitle,
            sex: dsex,
        } = defaultPatientDetails;

        return (
            firstName == dfirstName &&
            middleName == dmiddleName &&
            lastName == dlastName &&
            birthDate.split("T")[0] == dbirthDate.split("T")[0] &&
            title == dtitle &&
            sex == dsex
        );
    };

    const _syncInsuranceDetails = async (matchedPatient) => {
        const {
            insuranceType,
            insuranceId,
            insurance,
            membershipNo,
            membershipRefNo,
        } = matchedPatient;

        switch (insuranceType) {
            case 0:
                // Private
                insuranceDetails.membershipNo = membershipNo;
                insuranceDetails.membershipRefNo = membershipRefNo;
                patientDetails.insuranceId = insuranceId;
                await insuranceDetailsRef.loadInsuranceFund();
                await insuranceDetailsRef._syncInsuranceFund();
                break;
            case 10:
                // Overseas
                insuranceDetails.overseasCover = insurance;
                insuranceDetails.membershipNo = membershipNo;
                insuranceDetails.membershipRefNo = membershipRefNo;
                patientDetails.insuranceId = insuranceId;
                await insuranceDetailsRef.loadInsuranceFund();
                await insuranceDetailsRef._syncInsuranceFund();
                break;
            case 16:
                // Workers Compensation
                if (isFromQuote) break;

                const wcTempArr = insurance.replaceAll(" ", "").split("|");

                if (wcTempArr.length == 3) {
                    insuranceDetails.employer = wcTempArr[0];
                    insuranceDetails.employerEmail = wcTempArr[1];
                    workerCompensationObj.claimNumber = wcTempArr[2];
                } else if (wcTempArr.length == 4) {
                    insuranceDetails.employer = wcTempArr[2];
                    insuranceDetails.employerEmail = wcTempArr[3];
                    workerCompensationObj.insurerEmail = "";
                }

                await insuranceDetailsRef.loadWorkerCompensation(false);

                if ($workersCompensation.length)
                    workerCompensation = $workersCompensation.find(
                        (compensation) => compensation.id == insuranceId,
                    );

                if (workerCompensation?.id)
                    workerCompensationObj.insurerEmail =
                        workerCompensation.email;
                break;
            case 17:
                // Traffic Accident
                if (isFromQuote) break;

                trafficAuthorityObj.claimNumber = insurance;

                await insuranceDetailsRef.loadTrafficAuthorities(false);

                if ($trafficAccidentAuthorities.length)
                    trafficAuthority = $trafficAccidentAuthorities.find(
                        (authority) => authority.id == insuranceId,
                    );

                if (trafficAuthority?.id)
                    trafficAuthorityObj.email = trafficAuthority.email;
                break;
            case 20:
                // DVA
                // Data saved in patient details
                break;
            case 25:
            case 26:
                // Defence
                if (isFromQuote) break;

                const dTempArr = insurance.replaceAll(" ", "").split("|");
                insuranceDetails.pidNumber = dTempArr[0];
                insuranceDetails.danNumber = dTempArr[1];
                break;
            case 30:
                // Public in Private
                if (isFromQuote) break;

                const pipTempArr = insurance.replaceAll(" ", "").split("|");
                publicInPrivateObj.email = pipTempArr[0];
                publicInPrivateObj.vendorNumbers = pipTempArr[1];
            default:
                break;
        }
    };
</script>

{#if (isFromCreate || enableChangeEncounterDoctor) && displayMatchPatientStatus.displayStatus}
    <div class="flex items-center gap-x-2 col-span-2">
        {#if matchPatientStatus == 1}
            <Loader />

            <p class={`${displayMatchPatientStatus.textStyle}`}>
                {displayMatchPatientStatus.displayStatus}
            </p>
        {:else if !isObjectEmpty(matchPatientObj) && !isSamePatient}
            <button
                class="btn btn-secondary btn-sm"
                on:click|preventDefault={applyPatientDetails}
            >
                Apply match patient details
            </button>
        {:else}
            <p class={`${displayMatchPatientStatus.textStyle}`}>
                {displayMatchPatientStatus.displayStatus}
            </p>
        {/if}
    </div>
{/if}
